export default {
  computed: {
    titlePlaceholder () {
      return 'wypełnij dane'
    },
    namePlaceholder () {
      return 'Imię i nazwisko'
    },
    companyPlaceholder () {
      return 'Nazwa firmy'
    },
    emailPlaceholder () {
      return 'Adres e-mail'
    },
    ebookSubtitle () {
      return 'aby pobrać nasz e-book'
    },
    moduleSubtitle () {
      return 'aby pobrać nasz moduł'
    },
    ebookButton () {
      return 'pobierz e-book'
    },
    moduleButton () {
      return 'pobierz moduł'
    },
    agree () {
      return 'Wyrażam zgodę na przetwarzanie moich danych osobowych przez Smartbees Sp. z o.o. w celu otrzymywania informacji marketingowych za pomocą środków komunikacji elektronicznej. Administratorem danych osobowych jest Smartbees Sp. z o.o. (ul. Kępska 2/215, 45-129, Opole). Podanie danych jest dobrowolne. Każda osoba, której dane dotyczą, ma prawo dostępu do ich treści, poprawiania i ich usuwania.'
    },
    finishedTitle () {
      return 'Dziękujemy za zainteresowanie naszymi produktami!'
    },
    finishedEbookSubtitle () {
      return 'Niebawem na podanego przez Ciebie maila trafi e-book, który wybrałeś.'
    },
    finishedModuleSubtitle () {
      return 'Niebawem na podanego przez Ciebie maila trafi moduł, który wybrałeś.'
    },
    seeOtherProducts () {
      return 'zobacz nasze inne produkty'
    },
    goToBlog () {
      return 'przejdź na bloga'
    },
    industry () {
      return 'Branża'
    },
    captchaError () {
      return Drupal.t('Please check the captcha.')
    },
  }
}
